import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';

/**
 * ProtectedRoute — redirige a /login se l'utente non è autenticato.
 * Se l'utente deve cambiare la password, lo forza su /change-password.
 */
export default function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useUser();
  const location = useLocation();

  // Guest: redirect to login, preserving the intended destination
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.type)) {
    return <Navigate to="/home" replace />;
  }

  if (user.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}
